<div class="width-1100">

    <mat-card>
        <mat-toolbar class="toolbar-top">

            <div class='title'>
                <mat-icon>schedule</mat-icon>
                <div>Atividades</div>
            </div>
        </mat-toolbar>
    </mat-card>


    <mat-card>

        <mat-form-field class="full-width"  appearance="outline">
            <input matInput #memberSelected type="text" placeholder="Colaborador (4 letras iniciais)"
                [matAutocomplete]="autoMember" [formControl]="searchMemberControl">
            <mat-autocomplete #autoMember="matAutocomplete" [displayWith]="displayMember.bind(this)">
                <mat-option *ngFor="let member of members" [value]="member">
                    {{ member.name }}
                    <span *ngIf="member.email"> | <small>{{ member.email }}</small></span>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

    </mat-card>


    <mat-card id='table-body'>

        <!-- TABLE -->
        <mat-table [dataSource]="dataSource" matSort matSortDisableClear=true>

            <!-- name Column -->
            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
                <mat-cell *matCellDef="let element">

                    <ul>
                        <li *ngIf='element.event_name'>
                            <span style='font-weight: bold; color:rgba(0,0,0,.6);'>{{ element.event_name }}</span>
                        </li>
                        <li *ngIf='element.role_name'>
                            <span style='font-weight: bold; color:rgba(0,0,0,.6);'>{{ element.role_name }}</span>
                        </li>
                        <li *ngIf='element.day_name'>
                            {{element.day_date.seconds*1000 | date: 'dd/MM/yyyy'}} - {{ element.day_name }}
                        </li>
                        <li *ngIf='element.activity_name'>
                            {{ element.activity_startTime }} - {{ element.activity_name }}
                        </li>
                        <li *ngIf='element.topic_name'>
                            <span style='font-weight: bold; color:rgba(0,0,0,.6);'>
                                {{ element.topic_startTime }}
                            </span>
                            - {{ element.topic_name }}
                        </li>
                        <li *ngIf='element.topic_duration'>
                            {{ element.topic_duration }} minutos
                        </li>

                    </ul>

                </mat-cell>
            </ng-container>

            <!-- Row -->
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

        </mat-table>
        <!-- END TABLE -->

    </mat-card>

</div>